import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";

export default function FeaturedCollections() {
  const [lead, ...rest] = topics;

  return (
    <section id="collections" className="w-full bg-background-100 border-y border-background-200 scroll-mt-20">
      <div className="max-w-content mx-auto w-full px-4 md:px-8 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8 md:mb-10">
          <div>
            <span className="text-xs md:text-sm font-medium text-primary-600 tracking-wide">
              COLLECTIONS / 事件合集
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              一个话题，一条时间线
            </h2>
          </div>
          <Link
            to="/collections"
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部合集
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">
          <article className="lg:col-span-7">
            <Link
              to={`/topic/${lead.id}`}
              className="group flex flex-col h-full rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <div className="relative w-full h-56 md:h-72">
                <img
                  src={lead.cover}
                  alt={`${lead.title}事件合集封面`}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent"></div>
                <span className="absolute top-4 left-4 px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs">
                  {lead.category}
                </span>
                <span className="absolute top-4 right-4 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-background-50/90 text-accent-800 text-xs">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
                  {lead.status}
                </span>
                <h3 className="absolute bottom-4 left-4 right-4 font-heading text-xl md:text-2xl font-bold text-background-50">
                  {lead.title}
                </h3>
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <p className="text-sm text-foreground-700 leading-relaxed line-clamp-2">{lead.summary}</p>
                <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-fire-line text-primary-500"></i>
                    热度 {(lead.heat / 10000).toFixed(1)}万
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-refresh-line text-accent-600"></i>
                    {lead.updateCount} 次更新
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {lead.lastUpdate}
                  </span>
                </div>
                <div className="mt-4 pt-4 border-t border-background-200 flex flex-wrap gap-2">
                  {lead.tags.map((t) => (
                    <span key={t} className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-800 text-xs">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          </article>

          <div className="lg:col-span-5 flex flex-col gap-5 md:gap-6">
            {rest.slice(0, 3).map((t) => (
              <Link
                key={t.id}
                to={`/topic/${t.id}`}
                className="group flex gap-4 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
              >
                <div className="w-24 h-24 md:w-28 md:h-28 shrink-0 rounded-md overflow-hidden">
                  <img
                    src={t.cover}
                    alt={`${t.title}事件合集封面`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0 flex flex-col justify-center">
                  <div className="flex items-center gap-2">
                    <span className="text-xs text-primary-600">{t.category}</span>
                    <span className="text-xs text-foreground-400">· {t.lastUpdate}</span>
                  </div>
                  <h3 className="mt-1.5 font-heading text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
                    {t.title}
                  </h3>
                  <p className="mt-1 text-xs md:text-sm text-foreground-600 line-clamp-2">{t.summary}</p>
                  <span className="mt-2 inline-flex items-center gap-1 text-xs text-accent-700">
                    <i className="ri-refresh-line"></i>
                    {t.updateCount} 次更新
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}